'use client'

import { Box, Container, Divider, Link, List, ListItem, ListItemText, Typography } from '@mui/material'
import React from 'react'

// Data untuk setiap bagian kebijakan privasi untuk kemudahan pengelolaan
// Ikon telah dihapus dari data
const privacySections = [
	{
		title: '1. Perolehan dan Pengumpulan Data Pengguna',
		content: [
			{
				subtitle: 'A. Data yang Anda Berikan Secara Langsung',
				points: [
					'Informasi Akun: Nama lengkap, alamat email, nomor telepon, kata sandi, dan foto profil saat Anda mendaftar.',
					'Informasi Transaksi: Alamat pengiriman, rincian produk yang dibeli, data pembayaran (termasuk rincian kartu kredit/debit, rekening bank, atau e-wallet yang digunakan), dan data transaksi lainnya.',
					'Komunikasi: Rekaman dan isi percakapan saat Anda menghubungi layanan pelanggan kami atau berkomunikasi dengan penjual melalui fitur di Platform.',
					'Konten Lainnya: Informasi yang Anda berikan saat mengisi survei, ulasan produk, atau berpartisipasi dalam promosi.'
				]
			},
			{
				subtitle: 'B. Data yang Terekam Secara Otomatis',
				points: [
					'Data Lokasi: Informasi lokasi riil atau perkiraan (berdasarkan alamat IP atau GPS) saat Anda menggunakan layanan kami.',
					'Data Teknis: Alamat IP, informasi perangkat keras dan lunak (jenis dan versi browser, sistem operasi), ID iklan, serta unique device identifier (UDID).',
					'Data Penggunaan: Waktu dan durasi kunjungan Anda, produk yang dilihat, halaman yang diakses, dan interaksi lain di dalam Platform (log).'
				]
			},
			{
				subtitle: 'C. Data dari Sumber Pihak Ketiga',
				points: [
					'Mitra bisnis, penyedia layanan pembayaran, dan mitra logistik kami.',
					'Penyedia layanan otentikasi jika Anda mendaftar atau masuk menggunakan kredensial pihak ketiga (misalnya, Google atau Facebook).',
					'Sumber data publik yang tersedia secara umum.'
				]
			}
		]
	},
	{
		title: '2. Penggunaan Data',
		points: [
			'Pemrosesan Transaksi: Memvalidasi dan memproses pesanan, pembayaran, serta pengiriman produk Anda.',
			'Pengelolaan Akun: Memverifikasi identitas Anda dan mengelola akun Anda di UMKMs.',
			'Personalisasi Pengalaman: Menyesuaikan konten dan merekomendasikan produk yang relevan berdasarkan preferensi dan riwayat aktivitas Anda.',
			'Komunikasi dan Pemasaran: Menghubungi Anda terkait status pesanan, pembaruan layanan, serta mengirimkan informasi promosi dan pemasaran (Anda dapat berhenti berlangganan kapan saja).',
			'Pengembangan Platform: Menganalisis data penggunaan untuk memecahkan masalah (troubleshooting), meningkatkan keamanan, serta mengembangkan fitur dan layanan baru.',
			'Penegakan Hukum dan Kepatuhan: Mematuhi kewajiban hukum yang berlaku, menyelesaikan sengketa, dan menegakkan Syarat dan Ketentuan kami.'
		]
	},
	{
		title: '3. Pengungkapan Data Pribadi Pengguna',
		points: [
			'Mitra Penjual: Untuk memungkinkan penjual memproses dan memenuhi pesanan Anda.',
			'Mitra Logistik dan Pembayaran: Untuk memfasilitasi proses pengiriman dan transaksi pembayaran.',
			'Afiliasi dan Mitra Bisnis: Untuk tujuan promosi atau pengembangan layanan bersama, dengan persetujuan Anda terlebih dahulu.',
			'Otoritas Hukum: Jika diwajibkan oleh hukum atau perintah pengadilan yang sah, kami akan mengungkapkan data Anda kepada lembaga penegak hukum atau instansi pemerintah yang berwenang.',
			'Kepentingan Bisnis: Dalam hal terjadi restrukturasi korporat seperti merger, akuisisi, atau penjualan aset, data Anda dapat dialihkan sebagai bagian dari transaksi tersebut.'
		]
	},
	{
		title: '4. Cookies dan Teknologi Serupa',
		description: 'Cookies adalah file kecil yang ditempatkan di perangkat Anda untuk membantu kami mengenali Anda dan mengingat preferensi Anda. Kami menggunakan cookies untuk:',
		points: [
			'Mengingat informasi login Anda agar tidak perlu memasukkannya berulang kali.',
			'Menganalisis interaksi Anda di Platform untuk meningkatkan pengalaman pengguna.',
			'Menyajikan iklan yang lebih relevan bagi Anda.'
		],
		footer: 'Anda dapat mengelola atau menonaktifkan cookies melalui pengaturan browser Anda, namun beberapa fungsi di Platform kami mungkin tidak akan berjalan optimal.'
	},
	{
		title: '5. Keamanan dan Penyimpanan Data',
		description:
			'Kami menerapkan langkah-langkah keamanan teknis dan organisasi yang wajar untuk melindungi Data Pribadi Anda dari akses, penggunaan, atau pengungkapan yang tidak sah. Data Anda akan disimpan selama diperlukan untuk memenuhi tujuan yang dijelaskan dalam Kebijakan Privasi ini dan sesuai dengan peraturan perundang-undangan yang berlaku.'
	},
	{
		title: '6. Hak Pengguna',
		description: 'Anda memiliki hak untuk:',
		points: [
			'Mengakses, meninjau, dan memperbarui Data Pribadi Anda melalui pengaturan akun.',
			'Meminta penarikan persetujuan Anda untuk penggunaan data lebih lanjut.',
			'Meminta penghapusan Data Pribadi Anda dari sistem kami, sesuai dengan ketentuan yang berlaku.'
		]
	},
	{
		title: '7. Pembaruan Kebijakan Privasi',
		description:
			'Kami dapat meninjau dan mengubah Kebijakan Privasi ini dari waktu ke waktu untuk menyesuaikannya dengan perubahan layanan atau peraturan hukum. Setiap perubahan akan kami umumkan melalui Platform atau email. Kami menyarankan Anda untuk meninjau halaman ini secara berkala.'
	}
]

// Komponen utama untuk Halaman Kebijakan Privasi
export const PrivacyPolicySection: React.FC = () => {
	return (
		<Container maxWidth='lg'>
			<Box>
				{/* Header Halaman */}
				<Box className='text-center mb-8'>
					<Typography variant='h4' component='h1' className='font-bold text-gray-800 mb-2'>
						Kebijakan Privasi UMKMs
					</Typography>
					<Typography variant='subtitle1' className='text-gray-500'>
						Terakhir Diperbarui: 12 Juni 2024
					</Typography>
				</Box>

				{/* Intro */}
				<Typography variant='body1' className='mb-8 text-gray-700 leading-relaxed text-center max-w-4xl mx-auto'>
					Selamat datang di <strong>UMKMs</strong>, platform yang dikelola oleh <strong>PT UMKM Pintar Indonesia</strong>. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan,
					mengelola, mengungkapkan, dan melindungi Data Pribadi Anda saat Anda menggunakan layanan dan situs web kami (&quot;Platform&quot;).
				</Typography>

				<Divider className='my-8' />

				{/* Konten Kebijakan */}
				<Box className='space-y-8'>
					{privacySections.map((section, index) => (
						<div key={index}>
							<Typography variant='h5' component='h2' className='font-semibold text-gray-800 mb-3'>
								{section.title}
							</Typography>

							{section.description && (
								<Typography variant='body1' className='mb-3 text-gray-600'>
									{section.description}
								</Typography>
							)}

							{section.points && (
								<List dense={true}>
									{section.points.map((point, pIndex) => (
										<ListItem key={pIndex} sx={{ display: 'list-item', pl: 2 }}>
											<ListItemText
												primary={point}
												primaryTypographyProps={{
													className: 'text-gray-700'
												}}
											/>
										</ListItem>
									))}
								</List>
							)}

							{section.content &&
								section.content.map((sub, sIndex) => (
									<Box key={sIndex} className='mt-4 pl-4'>
										<Typography variant='h6' component='h3' className='font-medium text-gray-700 mb-2'>
											{sub.subtitle}
										</Typography>
										<List dense={true}>
											{sub.points.map((point, pIndex) => (
												<ListItem key={pIndex} sx={{ display: 'list-item', pl: 2 }}>
													<ListItemText
														primary={point}
														primaryTypographyProps={{
															className: 'text-gray-700'
														}}
													/>
												</ListItem>
											))}
										</List>
									</Box>
								))}
							{section.footer && (
								<Typography variant='body2' className='mt-3 text-gray-500 italic'>
									{section.footer}
								</Typography>
							)}
						</div>
					))}

					{/* Bagian Hubungi Kami */}
					<div>
						<Typography variant='h5' component='h2' className='font-semibold text-gray-800 mb-3'>
							8. Hubungi Kami
						</Typography>
						<Typography variant='body1' className='mb-3 text-gray-600'>
							Jika Anda memiliki pertanyaan, kekhawatiran, atau keluhan terkait privasi data Anda di UMKMs, silakan hubungi kami melalui:
						</Typography>
						<Box className='text-gray-800'>
							<Typography component='p' className='font-bold'>
								PT UMKM Pintar Indonesia
							</Typography>
							<Typography component='p'>
								<strong>Alamat:</strong> Gedung Artha Graha Lt. 9 Sudirman Central Business District Lot 25., Jl. Jend. Sudirman Kav. 52-53, Jakarta Selatan - 12190
							</Typography>
							<Typography component='p'>
								<strong>Email:</strong> halo@umkms.com / support@umkms.com
							</Typography>
							<Typography component='p'>
								<strong>Telepon:</strong>{' '}
								<Link href='tel:+6282123496617' color='inherit' underline='hover'>
									0821-2349-6617
								</Link>
							</Typography>
						</Box>
					</div>
				</Box>
			</Box>
		</Container>
	)
}
